import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotifications, markNotificationAsRead, markAllAsRead, removeNotification } from '../../redux/actions/notificationActions';
import IconCollection from '../../IconCollection/IconCollection';

const NotificationPanel = ({ notificationPanel }) => {
  const dispatch = useDispatch();
  const { notifications } = useSelector((state) => state.notificationReducer);

  useEffect(() => {
    dispatch(fetchNotifications()); // Fetch notifications on component mount
  }, [dispatch]);

  const calculateTimeAgo = (notificationTime) => {
    return moment(notificationTime).fromNow();
  };

  const handleMarkAsRead = (id) => {
    dispatch(markNotificationAsRead(id));
  };

  const handleMarkAllAsRead = () => {
    dispatch(markAllAsRead());
  };

  const handleRemoveNotification = (id) => {
    dispatch(removeNotification(id));
  };

  // Ensure notifications is always an array
  const notificationsArray = Array.isArray(notifications) ? notifications : [];

  const areAllNotificationsRead = notificationsArray.every(notification => notification.isRead);

  return (
    <div className={`fixed top-0 z-[3] right-0 left-0 bottom-0 bg-black bg-opacity-40 ${notificationPanel ? 'block' : 'hidden'}`}>
      <div className="notification-panel max-w-[312px] sm:max-w-[600px] w-full px-4 sm:px-10 py-3 sm:py-6 z-[4] absolute top-16 right-10 bg-white rounded-lg">
        <div className="flex justify-between flex-col sm:flex-row items-start sm:items-center">
          <p className="text-[#1A1A1A] font-bebas text-[32px]">Notifications</p>
          {!areAllNotificationsRead && (
            <button onClick={handleMarkAllAsRead} className="font-montserrat font-medium text-primary border-none">
              Mark all as read
            </button>
          )}
        </div>
        <div className="mt-3 flex flex-col gap-4 max-h-[450px] overflow-y-auto custom-scrollbar pr-3">
          {notificationsArray.slice(-10).map((notification, index) => (
            <button
              key={notification.id}
              className={`flex items-center gap-2 max-w-[520px] w-full p-4 rounded-md cursor-pointer ${notification.isRead ? 'bg-[#F2F2F2]' : 'bg-[#E2E2E2]'}`}
              onClick={() => handleMarkAsRead(notification.id)}
            >
              <div className={`w-3 h-3 sm:w-5 sm:h-5 rounded-full ${notification.isRead ? 'bg-green-500' : 'bg-red-500'}`}></div>
              <div className="text-xs sm:text-base flex-1 font-montserrat font-medium">
                {notification.message}
                <span className="text-primary">{notification.event}</span>
                {notification.time && <div className="inline pl-1">{notification.time}</div>}
              </div>
              <div className="hidden sm:flex flex-col justify-center items-center">
                <p className="block text-xs font-montserrat text-[#636363]">{calculateTimeAgo(notification.notificationTime)}</p>
                <button onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveNotification(notification.id);
                }}>
                  <IconCollection customClass="md:w-6 md:h-6 w-[10px] h-[10px]" name="close" />
                </button>
              </div>
            </button>
          ))}
        </div>
        <div className="flex justify-center items-center pt-4 text-base text-primary font-montserrat font-medium cursor-pointer">
          See all Notifications
        </div>
      </div>
    </div>
  );
};

NotificationPanel.propTypes = {
  notificationPanel: PropTypes.bool.isRequired,
};

export default NotificationPanel;
